module.exports = __webpack_public_path__ + "img/gn.c12b08b9.svg";